import Repository from "../../repository";

export default {
    GetListCustomizeTable: (payload) => Repository.post(`/api/customize-table-ver2/GetListCustomizeTable`, payload),
    GetByEntryID: (payload) => Repository.post(`/api/customize-table-ver2/GetByEntryID`, payload),
    GetByTableCode: (payload) => Repository.post(`/api/customize-table-ver2/GetByTableCode`, payload),
    Add: (payload) => Repository.post(`/api/customize-table-ver2/Add`, payload),
    Edit: (payload) => Repository.post(`/api/customize-table-ver2/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/customize-table-ver2/Delete`, payload),
    AddRange: (payload) => Repository.post(`/api/customize-table-ver2/AddRange`, payload),
    CopyTable: (payload) => Repository.post(`/api/customize-table-ver2/CopyTable`, payload),
};
